import { RegressionTierDiagnostic } from '@aloft/toolkit-shared/lib/tkv2OrderAttachments/schemas/unitRateModels.js';
import {
  Flex,
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  Typography,
} from '@aloft/toolkit-sui';

const formatPercent = (value?: number) =>
  value === undefined ? '—' : `${(value * 100).toFixed(1)}%`;

export const RegressionTierComparison = ({ tiers }: { tiers?: RegressionTierDiagnostic[] }) => {
  if (!tiers?.length) return null;

  return (
    <Flex flexDirection="column" gap="12px">
      <Typography variant="h4">Tier Comparison</Typography>
      <TableContainer>
        <Table>
          <Thead>
            <Tr>
              <Th>Tier</Th>
              <Th>Transactions</Th>
              <Th>R²</Th>
              <Th>In-sample Error</Th>
              <Th>Out-of-sample Error</Th>
              <Th>Status</Th>
            </Tr>
          </Thead>
          <Tbody>
            {tiers.map((tier) => (
              <Tr key={tier.filterTier}>
                <Td>
                  <Typography variant="body2">{tier.filterTier}</Typography>
                </Td>
                <Td>
                  <Typography variant="body2">{tier.transactionCount}</Typography>
                </Td>
                <Td>
                  <Typography variant="body2">
                    {tier.modelDiagnostics ? tier.modelDiagnostics.rSquared.toFixed(2) : '—'}
                  </Typography>
                </Td>
                <Td>
                  <Typography variant="body2">
                    {formatPercent(tier.modelDiagnostics?.standardErrorRatio)}
                  </Typography>
                </Td>
                <Td>
                  <Typography variant="body2">
                    {formatPercent(tier.modelDiagnostics?.crossValidatedStandardErrorRatio)}
                  </Typography>
                </Td>
                <Td>
                  <Typography
                    variant="body2"
                    color={tier.status === 'selected' ? 'textSuccess' : 'textSecondary'}
                  >
                    {tier.status === 'selected'
                      ? 'Selected'
                      : (tier.unavailableReason ?? 'Available')}
                  </Typography>
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </TableContainer>
    </Flex>
  );
};
